/* eslint-disable object-property-newline,sort-keys,object-property-newline */
import { ScreenTypes } from './ScreensList';

enum TagSections {
  REQUIRED = 'required',
  CUSTOMER = 'customer',
  CART = 'cart',
  TICKET = 'ticket',
  OPERATION = 'operation',
  SITE = 'site',
  PROFILE = 'profile',
  TOKEN = 'token',
}

/*
 * map is target
 * Section is used for display order in PMP
 * screens allow to filter tags to know on which screens they will be displayed in PMP
 */
export type Tag = { label: string, tag: { map: string, section?: TagSections, screens: ScreenTypes[], conditions?: Record<string, unknown> } };
export type TagBag = Array<Tag>;

export const AvailableTags: TagBag = [
  { label: 'Gain', tag: { map: 'gamePlayed.prize', section: TagSections.TICKET, screens: [ScreenTypes.WON] } },
  { label: 'reward', tag: { map: 'experience.payload.prize', section: TagSections.TICKET, screens: [ScreenTypes.HOME] } },
  { label: 'Legal Url', tag: { map: 'operation.legal', section: TagSections.OPERATION, screens: [ScreenTypes.HOME] } },
  { label: 'Game Count', tag: { map: 'gameCount', section: TagSections.SITE, screens: [ScreenTypes.MULTIGAME] } },
  { label: 'Dotation Code', tag: { map: 'gamePlayed.dotationCode', section: TagSections.TICKET, screens: [ScreenTypes.WON], conditions: {
    'operation.dotations.win.activ': true,
    'operation.instant.activ': true,
  } } },
  { label: 'Dotation Code', tag: { map: 'gamePlayed.dotationCode', section: TagSections.TICKET, screens: [ScreenTypes.LOST], conditions: {
    'operation.dotations.lose.activ': true,
  } } },
  { label: 'Main proba fraction', tag: { map: 'experience.payload.mainProbaFraction', section: TagSections.TICKET, screens: [ScreenTypes.HOME] } },
];
